import { Anchor, AnchorProps } from 'grommet';
import React, { ReactNode } from 'react';
import { Link } from 'react-router-dom';

type LinkItemProps = {
  route: string;
  label?: string;
  children?: ReactNode;
  linkStyle?: Record<string, string>;
  onClick?: (value: any) => void;
} & AnchorProps;

const scrollToTop = () =>
  window.scroll({
    top: 0,
    left: 0,
    behavior: 'smooth',
  });

export const LinkItem = ({
  route,
  label,
  children,
  linkStyle,
  color,
  ...props
}: LinkItemProps) => (
  <Link
    to={route}
    style={{ textDecoration: 'none', whiteSpace: 'nowrap', ...linkStyle }}
  >
    <Anchor
      onMouseUp={() => scrollToTop()}
      as="span"
      color={color || 'white'}
      {...props}
    >
      {label || children}
    </Anchor>
  </Link>
);
